"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  REPLACE: 'replace',
  CROP: 'crop',
  EDIT: 'edit',
  DELETE: 'delete',
  LOGOUT: 'logout',
  SUPPORT: 'support',
  FAQ: 'faq',
  DUPLICATE: 'duplicate',
  REMOVE_BG: 'remove-bg',
  BILLING: 'billing'
};
exports.default = _default;